import * as OptionalOriginAccessors from './accessors';
import * as OptionalOriginDerivers from './derivers';
import * as OptionalOriginGenerators from './generators';
import * as OptionalOriginSimulators from './simulators';
import * as OptionalOriginTypings from './typings';
import * as OptionalOriginUtils from './utils';
export * from './typings';
export { OptionalOriginAccessors, OptionalOriginDerivers, OptionalOriginGenerators, OptionalOriginSimulators, OptionalOriginUtils, };
export default Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, OptionalOriginAccessors), OptionalOriginDerivers), OptionalOriginGenerators), OptionalOriginTypings), OptionalOriginUtils), OptionalOriginSimulators);
